import * as Sentry from '@sentry/vue';

export default function setupErrorReporting(app) {
    try {
        const props = JSON.parse(
            document.getElementById('app')?.dataset.page
        ).props;

        const userId = props?.auth?.user?.id;
        const dsn = props?.sentry.dsn;
        const release = props?.sentry.release;

        if (!dsn) {
            return;
        }

        if (userId) {
            Sentry.setUser({id: userId});
        }

        Sentry.init({
            app,
            dsn,
            integrations: [Sentry.replayIntegration()],
            tracesSampleRate: 0.1,
            tracePropagationTargets: [],
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
            release: release,
        });
    } catch {
    }
}

